import React from 'react';
import { Link } from 'react-router';

const menuItems = [
  { label: 'Country profiles', path: '/' },
  { label: 'Statistics', path: '/statistics' },
  { label: 'International assistance', path: '/international-assistance' },
  { label: 'National reports', path: '/national-reports' },
  { label: 'Diversion', path: '/diversion' },
  { label: 'Regional organizations', path: '/regional-organization' },
  { label: 'National points of contact', path: '/national-contacts' },
  { label: 'SDGs', path: '/sustainable-development-goals' }
];

function MenuItem (props) {
  const activeClassName = (props.isActive) ? "active" : "";
  return (
    <li role="presentation">
      <Link className={ activeClassName } to={ props.to }>
        { props.children }
      </Link>
    </li>
  );
};

class Menu extends React.PureComponent {
  renderItems() {
    let currentPath = this.props.currentPath;

    return menuItems.map(item => {
      let isActive = currentPath ? (item.path === currentPath) : (item.path === "/");

      return (
        <MenuItem
          key={ item.path }
          isActive={ isActive }
          to={ item.path }
        >
          { item.label }
        </MenuItem>
      );
    });
  }

  render () {
    return (
      <nav className="poa-nav">
        <ul className="nav nav-pills">
          { this.renderItems() }
        </ul>
      </nav>
    );
  }
}
export default Menu;



// WEBPACK FOOTER //
// ./src/components/common/Menu.js